/**
 * Created by intellicar-rinas on 20/9/17.
 */
import React, {Component} from 'react';

class Loader extends Component{

    render(){
        return null;
    }

    componentDidMount(){
        if(this.props.load){
            this.props.load(this.props.params);
        }
    }
}

class CallbackBuddy extends Component{

    render(){
        return (
            this.props.if ? (
                <Loader load={this.props.then}/>
            ) : null
        )
    }

    componentWillReceiveProps(props){
        if(this.props.onDataChange){
            this.props.onDataChange(props.if);
        }
    }

}

export default CallbackBuddy;